var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1121"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1121"
    },
    "bundlingPackage": "customer-portal-app",
    "bundlingPackageVersion": "static-1.1857",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};